// Erkennt, ob die App in einem iframe/einer Host-Seite eingebettet ist.
// Bei Cross-Origin kann der Zugriff auf window.top scheitern -> dann sind wir eingebettet.
function isEmbedded(): boolean {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
}

// Etwas Luft oberhalb des #root, damit der Anfang nicht am Fensterrand klebt.
const ROOT_SCROLL_OFFSET = 20;

// Standalone: zum #root scrollen (leicht darüber) statt hart auf top 0.
function scrollWindowToRoot(): void {
  const root = document.getElementById('root');
  const top = root
    ? root.getBoundingClientRect().top + window.scrollY - ROOT_SCROLL_OFFSET
    : 0;

  window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
}

// Nach oben scrollen: eingebettet via postMessage an die Host-Seite,
// standalone direkt zum #root im eigenen Fenster.
export function scrollToTop(): void {
  if (isEmbedded()) {
    window.parent.postMessage(JSON.stringify({ type: 'scrollToTop' }), '*');
    return;
  }

  scrollWindowToRoot();
}

// Backwards-kompatibler Alias: bisher genutzt beim Step-Wechsel/Navigation.
export const scrollToRef = scrollToTop;

// Bei Fehlermeldungen: eingebettet kann scrollIntoView die Host-Seite nicht bewegen,
// daher die Host-Seite nach oben scrollen; standalone direkt zum Fehler-Element.
export function scrollToError(ref: { current: HTMLElement | null }): void {
  if (isEmbedded()) {
    window.parent.postMessage(JSON.stringify({ type: 'scrollToTop' }), '*');
    return;
  }

  ref.current?.scrollIntoView({ behavior: 'smooth' });
}
